import React from "react"
import clsx from "clsx"

import { BicycodeActiveIcon } from "components/Elements/Icons/BicycodeActiveIcon"
import { BicycodeIcon } from "components/Elements/Icons/BicycodeIcon"
import { MFCActiveIcon } from "components/Elements/Icons/MFCActiveIcon"
import { MFCIcon } from "components/Elements/Icons/MFCIcon"
import MoustacheActiveIcon from "components/Elements/Icons/MoustacheActiveIcon"
import MoustacheIcon from "components/Elements/Icons/MoustacheIcon"
import { useAsideMenu, useTheme } from "hooks"
import { Operator } from "models"
import { MC_OPERATOR_NAME, BC_OPERATOR_NAME, MFC_OPERATOR_NAME } from "utils/constants"

const ICON_SIZE = 40

export const SelectOperatorIcon: React.FC = () => {
	const { operatorsUser } = useAsideMenu()
	const { currentTheme, toggleTheme } = useTheme()

	return (
		<header className={clsx("h-[194px] flex items-center flex-col")}>
			{operatorsUser?.map((operator: Operator) => {
				const isCurrentOperator = operator.id_api === currentTheme.id_api
				const isMoustacheOperator = operator.name === MC_OPERATOR_NAME
				const isBicycodeOperator = operator.name === BC_OPERATOR_NAME
				const isMFCOperator = operator.name === MFC_OPERATOR_NAME

				const formElementCommonProps = {
					className: "mb-5",
					onClick: () => toggleTheme(operator),
					key: operator.id_api,
				}

				if (isMoustacheOperator) {
					return (
						<button {...formElementCommonProps}>
							{isCurrentOperator ? (
								<MoustacheActiveIcon size={ICON_SIZE} className="" />
							) : (
								<MoustacheIcon size={ICON_SIZE} className="" />
							)}
						</button>
					)
				} else if (isBicycodeOperator) {
					return (
						<button {...formElementCommonProps}>
							{isCurrentOperator ? (
								<BicycodeActiveIcon size={ICON_SIZE} className="" />
							) : (
								<BicycodeIcon size={ICON_SIZE} className="" />
							)}
						</button>
					)
				} else if (isMFCOperator) {
					return (
						<button {...formElementCommonProps}>
							{isCurrentOperator ? (
								<MFCActiveIcon size={ICON_SIZE} className="" />
							) : (
								<MFCIcon size={ICON_SIZE} className="" />
							)}
						</button>
					)
				}
				return null
			})}
		</header>
	)
}
